import React from 'react'
import WiderPinocdeImg from "../../../../../assets/image/widerPinocde.svg"

const WiderPinocde = () => {
    return (
        <>
            <img src={WiderPinocdeImg} alt="" style={{ maxHeight: '85%' }} />
        </>
    )
}

export default WiderPinocde